import { render } from "./FooterLayout.vue?vue&type=template&id=0bd82941"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/classic/FooterLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bd82941"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bd82941', __exports__)) {
    api.reload('0bd82941', __exports__)
  }
  
  module.hot.accept("./FooterLayout.vue?vue&type=template&id=0bd82941", () => {
    api.rerender('0bd82941', render)
  })

}


export default __exports__